export default __webpack_public_path__ + "static/media/logo-motor-volta-new-white.1e3ff03f.png";